module.exports = __webpack_public_path__ + "img/bannerGreen.70a644ef.jpg";